import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import BackgroundD from '../../../static/images/millas-plus-salas/hero-image-desktop.jpg'
import BackgroundM from '../../../static/images/millas-plus-salas/hero-image-mobile.jpg'

const Container = styled.div`
  background-image:url(${BackgroundM});
  background-repeat: no-repeat;
  background-position:center;
  background-size: cover;
  position: relative;
  text-align: center;
  margin: 0 auto;
  ${breakpoint('tablet')`
    background-image:url(${BackgroundD}) !important;
  `}
  h1 {
    font-size: 2.8em;
    margin: 0 0 0.3em;
    color: black;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  h3 {
    font-size: 19px;
    font-weight: 400;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

 

  ${breakpoint('tablet')`
    & h1:first-child {
      font-size: 40px !important;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`


const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
  </Container>
);

export default Header